import styled, { css } from 'styled-components'
import { UITypes } from 'LibNeo/constants/UIConstants'
import { Indent } from 'LibNeo/components/Basic/Indent'
import { IconComponent } from 'LibNeo/components/Basic/Icon/Icon'
import { themeColor, themeFontFamily } from 'LibNeo/theme'
import { CLOSE_ANIMATION } from 'Constants/Global'

type ComponentsProps = {
	type: UITypes
	isBanner?: boolean
	isClosedBanner?: boolean
	heightNotifContainer?: number
}

const iconsColorsByType = {
	[UITypes.DANGER]: themeColor('pink', 5),
	[UITypes.PRIMARY]: themeColor('emerald', 5),
	[UITypes.WARNING]: themeColor('gold', 5),
	[UITypes.INFO]: themeColor('blue', 5),
	[UITypes.PASSIVE]: themeColor('gray', 5),
}

const backgroundColorsByType = {
	[UITypes.DANGER]: themeColor('pink', 1),
	[UITypes.PRIMARY]: themeColor('emerald', 1),
	[UITypes.WARNING]: themeColor('gold', 1),
	[UITypes.INFO]: themeColor('blue', 1),
	[UITypes.PASSIVE]: themeColor('gray', 1),
}

export const NotificationContainer = styled.div<ComponentsProps>`
	display: flex;
	padding: 16px;
	border-radius: 6px;
	font-family: ${themeFontFamily('SBSansInterface')};
	background-color: ${({ type }) => backgroundColorsByType[type]};

	${({ isBanner, heightNotifContainer }) =>
		isBanner &&
		css`
			border-radius: 0;
			padding: 12px 36px;
			align-items: center;
			margin-top: -${heightNotifContainer}px;
			animation: animation ${CLOSE_ANIMATION}ms forwards 1200ms;
			@keyframes animation {
				0% {
					margin-top: -${heightNotifContainer}px;
				}
				100% {
					margin-top: 0;
				}
			}
		`}

	${({ isClosedBanner, heightNotifContainer }) =>
		isClosedBanner &&
		css`
			margin-top: 0;
			animation: animationClose ${CLOSE_ANIMATION}ms forwards;
			@keyframes animationClose {
				0% {
					margin-top: 0;
				}
				100% {
					margin-top: -${heightNotifContainer}px;
				}
			}
		`}
`

export const ContentContainer = styled.div<Pick<ComponentsProps, 'isBanner'>>`
	flex-grow: 1;
	display: flex;

	${({ isBanner }) =>
		isBanner &&
		css`
			border-radius: 0;
			justify-content: center;
			align-items: flex-start;
			margin-right: 40px;
		`}
`

export const Icon = styled(IconComponent)<Pick<ComponentsProps, 'type'>>`
	flex-shrink: 0;
	margin: 0 12px 0 0;
	fill: ${({ type }) => iconsColorsByType[type]};
`

export const IconClose = styled(IconComponent)`
	flex-grow: 0;
	flex-shrink: 0;
	svg {
		fill: ${themeColor('gray', 4)};
	}
`

export const BannerText = styled.span`
	font-size: 12px;
	line-height: 20px;
	font-family: ${themeFontFamily('SBSansText')};
	color: ${themeColor('gray', 8)};
	white-space: pre-wrap;
	overflow-wrap: anywhere;
`

export const NotificationTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 12px;
	line-height: 20px;
	white-space: pre-wrap;
	overflow-wrap: anywhere;
`

export const NotificationTitle = styled.span`
	font-size: 14px;
	font-family: ${themeFontFamily('SBSansText')};
	color: ${themeColor('gray', 8)};
`

export const NotificationDescription = styled.span`
	font-family: ${themeFontFamily('SBSansText')};
	color: ${themeColor('gray', 8)};
`

export const ActionsWrapper = styled(Indent)`
	display: flex;
`
